import React from "react";
import { Button, Stack } from "@mui/material";

export const MANAGE_QUEUES_LABEL = "Manage Queues";
export const PRIORITIZE_WORK_LABEL = "Prioritize Work";

interface IProps {
    /** Absent handler => that button is not rendered. */
    onManageQueues?: () => void;
    onPrioritizeWork?: () => void;
}

/** Button order is asserted in the tests; it must not become configurable. */
const ManagerActionButtons: React.FC<IProps> = ({ onManageQueues, onPrioritizeWork }) => {
    if (!onManageQueues && !onPrioritizeWork) return null;

    return (
        <Stack direction="row" spacing={1} justifyContent="flex-end" width="100%">
            {onManageQueues && (
                <Button variant="outlined" size="small" onClick={onManageQueues}>
                    {MANAGE_QUEUES_LABEL}
                </Button>
            )}
            {onPrioritizeWork && (
                <Button variant="outlined" size="small" onClick={onPrioritizeWork}>
                    {PRIORITIZE_WORK_LABEL}
                </Button>
            )}
        </Stack>
    );
};

export default ManagerActionButtons;
